export const translationModeration_da = {
  blockVisitor: "Bloker besøgende",
  blockVisitorTitle: "Bloker denne besøgende?",
  blockVisitorDescription:
    "De kan ikke længere se eller bruge chatten på nogen af jeres organisations chatbots. I kan til enhver tid ophæve blokeringen under Indstillinger, Blokerede besøgende.",
  blockDuration: "Bloker i",
  blockDays1: "1 dag",
  blockDays7: "7 dage",
  blockDays30: "30 dage",
  blockDays90: "90 dage",
  blockConfirm: "Bloker besøgende",
  cancel: "Annuller",
  visitorBlocked: "Den besøgende er blokeret.",
  visitorAlreadyBlocked: "Denne besøgende er allerede blokeret.",
  visitorNotBlockable: "Kun live-samtaler med en kendt besøgende kan blokeres.",
  blockFailed: "Den besøgende kunne ikke blokeres. Prøv igen.",
  moderationFlagged: "Moderering markerede {count} beskeder: {categories}.",
  moderationFlaggedOne: "Moderering markerede en besked: {categories}.",
  moderationWouldBlock:
    "Moderering ville have blokeret denne besøgende, men blokerede dem ikke automatisk.",
  moderationBlockedUntil: "Denne besøgende er blokeret indtil {date}.",
  categoryRude: "Uhøflig",
  categoryOfftopic: "Uden for emnet",
  categoryNonsense: "Volapyk",
  categoryAbuse: "Chikane",
  categoryAttack: "Angrebsforsøg",
  categorySpam: "Spam",
  badgeBlocked: "Blokeret",
  badgeWouldBlock: "Ville blokere",
  badgeFlagged: "Markeret",
  filterMisuse: "Misbrug",
  filterWouldBlock: "Ville blokere",
  pageTitle: "Blokerede besøgende",
  pageDescription:
    "Besøgende, der er holdt ude af jeres organisations chats, blokeret af jeres team eller af moderering. Kun et fingeraftryk af hver adresse gemmes, aldrig selve adressen.",
  columnReason: "Årsag",
  columnConversation: "Samtale",
  columnBlocked: "Blokeret",
  columnExpires: "Indtil",
  columnActions: "Handlinger",
  reasonManual: "Af jeres team",
  reasonAttack: "Angrebsforsøg",
  reasonAbuse: "Gentagen chikane",
  openConversation: "Åbn samtale",
  unblock: "Ophæv blokering",
  unblockTitle: "Ophæv blokeringen af denne besøgende?",
  unblockDescription: "De kan bruge chatten igen med det samme.",
  unblocked: "Blokeringen er ophævet.",
  unblockFailed: "Blokeringen kunne ikke ophæves. Prøv igen.",
  noBlocks: "Ingen besøgende er blokeret.",
  loadFailed: "Blokerede besøgende kunne ikke indlæses.",
  exemptionsTitle: "Blokeres aldrig automatisk",
  exemptionsDescription:
    "Adresser, som moderering aldrig blokerer af sig selv, fx jeres kontor eller en sikkerhedstester, I har hyret. Jeres team kan stadig blokere dem.",
  exemptionAddress: "IP-adresse",
  exemptionName: "Navn",
  addExemption: "Tilføj adresse",
  removeExemption: "Fjern",
  removeExemptionLabel: "Fjern {name}",
  exemptionAdded: "Adressen er undtaget.",
  exemptionInvalid: "Angiv en gyldig IP-adresse og et navn.",
  exemptionExists: "Den adresse er allerede undtaget.",
  exemptionFailed: "Adressen kunne ikke gemmes. Prøv igen.",
  noExemptions: "Ingen adresser er undtaget.",
  loadingMore: "Indlæser flere",
};
